"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: theme.mixins.gutters({
      display: 'flex',
      flexDirection: 'column'
    })
  };
}, {
  name: 'SxWebPageFooterColumn'
});

function PageFooterColumn(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  return _react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), children);
}

PageFooterColumn.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
};
PageFooterColumn.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined
};
var _default = PageFooterColumn;
exports.default = _default;